// Adam's announcement for this product, where a page layout has its Announcements section ("Shows
// only while you have 1 posted for this product", AdminLayout.dc.html). No product board draws 1, so
// it takes the Library's card (Main.dc.html) in the product's look: who it's from, the headline, the
// line and its button.
import { Link } from '../lib/router.jsx'

export function ProductAnnouncement({ announcement }) {
  if (!announcement) return null
  return (
    <section className="pp-news" aria-label="From Adam">
      <span className="pp-news-from">{announcement.from}</span>
      <span className="pp-news-headline">{announcement.headline}</span>
      {announcement.line && <span className="pp-news-line">{announcement.line}</span>}
      {announcement.button && <Link to={announcement.button.href} className="pp-news-btn">{announcement.button.label}</Link>}
    </section>
  )
}
